import type { NodeViewProps } from "@tiptap/react";
import type { RefNodeFragment } from "../client/generated";
import type { RegionType } from "../types/utils";
import { NodeViewWrapper } from "@tiptap/react";
import { cn } from "@acdc2/ui/lib/utils";
import { getRegionName, getRegionType } from "../types/utils";
import { RegionThumbnail } from "../regions/RegionThumbnail";
import { useTranslation } from "react-i18next";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "@acdc2/ui/components/hover-card";

export function RefNode(props: NodeViewProps) {
  const { t } = useTranslation();

  const fragment: RefNodeFragment = props.extension.options.fragment;
  const regionId = props.node.attrs.regionId;
  const region = fragment.regions.find((region) => region.id === regionId);
  const regionType: RegionType = region ? getRegionType(region) : "untyped";

  return (
    <NodeViewWrapper
      className={cn(
        "inline-block bg-region-formula-mid text-white rounded-sm px-1",
        {
          "bg-region-untyped-mid": regionType === "untyped",
          "bg-region-hybrid-mid": regionType === "hybrid",
          "bg-region-heading-mid": regionType === "heading",
          "bg-region-caption-mid": regionType === "caption",
          "bg-region-formula-mid": regionType === "formula",
          "bg-region-figure-mid": regionType === "figure",
          "bg-region-image-mid": regionType === "image",
          "bg-region-list-mid":
            regionType === "list" ||
            regionType === "listItem" ||
            regionType === "sublist",
          "bg-region-artifact-mid": regionType === "artifact",
          "bg-region-table-mid": regionType === "table",
          "bg-region-toc-mid": regionType === "toc",
          "bg-region-text-mid": regionType === "text",
        },
      )}
    >
      {region ? (
        <HoverCard openDelay={0} closeDelay={0}>
          <HoverCardTrigger>{getRegionName(region)}</HoverCardTrigger>
          <HoverCardContent className="w-auto min-w-64">
            <RegionThumbnail fragment={region} />
          </HoverCardContent>
        </HoverCard>
      ) : (
        <span>{t("RefNode.invalid")}</span>
      )}
    </NodeViewWrapper>
  );
}
